export enum DeleteModeratorActionTypes {
  DELETING = 'moderators/DELETING',
  DELETED = 'moderators/DELETED',
  ERROR = 'moderators/DELETE-ERROR',
}
